export default __webpack_public_path__ + "static/media/tick.5d79884e.svg";